import type {SVGProps} from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
    ariaLabel?: string;
    alt?: string;
}

const Icon = ({ariaLabel, className, width, height, viewBox, children, alt, fill, onClick, ...rest}: IconProps) => {
    const viewBoxResult = viewBox ?? `0 0 ${width} ${height}`;

    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            viewBox={viewBoxResult}
            className={className}
            aria-label={ariaLabel}
            aria-hidden={ariaLabel ? undefined : true}
            fill={fill}
            onClick={onClick}
            {...rest}
        >
            {children}
        </svg>
    );
};

export default Icon;
